export default __webpack_public_path__ + "88423199449b2d18f80e2af9f70e3a5a.png";